import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, computed, input, OnInit } from '@angular/core';

import { FormControl } from '@angular/forms';

import { faCaretUp, faCaretDown, faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons';

import { QuestionOption } from '@empathy/survey/base';
import { Question } from '@empathy/survey/base';

@Component({
  selector: 'empathy-ranking-question-view',
  templateUrl: './ranking-question-view.component.html',
  styleUrls: ['./ranking-question-view.component.scss', '_ranking-question-view-theme.component.scss']
})
export class RankingQuestionViewComponent implements OnInit {
  question = input<Question>(null);
  questionCtrl = input<FormControl>();

  options$ = computed(() => this.mapOptions());

  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;
  faGripDotsVertical = faGripDotsVertical;

  ngOnInit(): void {
    if (!this.questionCtrl().value) {
      this.questionCtrl().setValue(this.question().visibleOptions.map((val) => val.value));
    }
  }

  drop(event: CdkDragDrop<QuestionOption[]>): void {
    this.moveOptionInArray(event.previousIndex, event.currentIndex);
  }

  onMoveCard(previousIndex: number, currentIndex: number): void {
    this.moveOptionInArray(previousIndex, currentIndex);
  }

  private mapOptions(): QuestionOption[] {
    if (this.questionCtrl().value?.length > 0) {
      return this.questionCtrl().value.map((val: string) => this.question()?.visibleOptions.find((option) => option.value === val));
    }

    return this.question().visibleOptions;
  }

  private moveOptionInArray(previousIndex: number, currentIndex: number): void {
    const updatedValues = this.options$();
    moveItemInArray(updatedValues, previousIndex, currentIndex);
    this.questionCtrl().setValue(updatedValues.map((val) => val.value));
  }
}
